export default {
	apiUrl: 'https://docasnyemail.sk/api/v1/mail',
	domain: 'docasnyemail.sk'
 }
 


//////////////////
// WEBPACK FOOTER
// ./config/apiconfig.js
// module id = null
// module chunks = 